<template>
    <div class="reports">
        <div>
            <div>
                <div class="informes">
                    <div>
                        <div><label>Modelos<br><br> <span>{{cantModelos}}</span></label></div>
                        <div><label>Dolares <br><br> <span>{{priceFormat(totalDolars)}}</span></label></div>
                        <div><label>Tokens <br><br> <span>{{parseInt(totalDolars / 0.05)}}</span></label></div>
                    </div>
                </div>
                <div class="ledgers">
                    <div>
                        <h3 for="">Ultimos ingresos</h3>
                        <input type="date" v-model="searchValue" v-on:keyup="checkTrigger" @keyup.enter="onEnter">
                        <center>
                            <table v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="200">
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Modelo</th>
                                        <th>Tokens</th>
                                        <th>Dolar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ledger, index) in ledgers" :key="index">
                                        <td>{{ledger.date.split($store.state.constants.SEPARETOR)[0]}}</td>
                                        <td>{{ledger.modelo}}</td>
                                        <td>{{ledger.tokens}}</td>
                                        <td>{{priceFormat(ledger.dolars)}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </center>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div>
                <div class="modelos">
                    <div>
                        <div>
                            <h4>Mayor Producción</h4>
                            <center>
                                <table>
                                    <tbody>
                                        <tr v-for="(platform, index) in bestModels" :key="index">
                                            <td>{{platform.modelo}}</td>
                                            <td>{{priceFormat(platform.balance)}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </center>
                        </div>
                        <div>
                            <h4>Menor Producción</h4>
                            <center>
                                <table>
                                    <tbody>
                                        <tr v-for="(platform, index) in worseModels" :key="index">
                                            <td>{{platform.modelo}}</td>
                                            <td>{{priceFormat(platform.balance)}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </center>
                        </div>
                    </div>
                </div>
                <div class="fechas">
                    <div>
                        <div>
                            <div>
                                <label for="">Total Ayer<br><br> <span>{{priceFormat(totalTokensToday)}}</span></label>
                            </div>
                            <div>
                                <label for="">Studio ganancias <br><br> <span>{{priceFormat(studioTotal)}}</span></label>
                            </div>
                        </div>
                        <div>
                            <div>
                                <label for="" v-if="bestDay">Dia mas vendido <br><br> <span>fecha: {{bestDay.created_at !== null ? bestDay.created_at.split("T")[0] : ''}} <br>total: {{bestDay.total !== null ? priceFormat(bestDay.total): priceFormat(0.00)}}</span></label>
                            </div>
                            <div>
                                <label for="" v-if="worseDay">Dia menos vendido <br><br> <span>fecha: {{worseDay.created_at !== null ? worseDay.created_at.split("T")[0]: ''}} <br>total: {{worseDay.total !== null ? priceFormat(worseDay.total): priceFormat(0.00)}}</span></label>
                            </div>
                       </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import Price from '@/utils/ConvertPriceNumber'

export default {
    data() {
        return {
            cantModelos: null,
            totalDolars: null,
            totalTokens: null,
            ledgers: [],
            limit: 20,
            offset: 0,
            busy: false,
            listEnd: false,
            itemFlag: false,
            bestModels: [],
            worseModels: [],
            totalTokensToday: 0,
            bestDay: null,
            worseDay: null,
            studioTotal: 0.00,
            searchValue: ''
        }
    },
    watch: {
        searchValue: function() {
            if (this.searchValue === '') {
                this.ledgers = []
                this.getPlatformsLedgers()
            }
        }
    },
    methods: {
        checkTrigger(e) {
            if (e.keyCode === 13) {
                this.limit = 20
                this.offset = 0
                this.ledgers = []
                this.searchLedger()
            } else if (this.searchValue.length > 0) {
                this.limit = 20
                this.offset = 0
                this.ledgers = []
                this.searchLedger()
            }
        },
        onEnter () {
            this.searchLedger()
        },
        searchLedger() {
            this.modelSearch = false
            this.getPlatformsLedgers()
        },
        priceFormat: function(item) {
            return Price(item)
        },
        getTotalModels() {
            API.getTotalModelsByPlatform('Chaturbate')
                .then((res) => {
                    this.cantModelos = res.cantidad
                })
        },
        getTotalDollars() {
            API.getTotalDollarsByPlatform('Chaturbate')
                .then((res) => {
                    this.totalDolars = res.dolars
                })
        },
        getPlatformsLedgers() {
            const limit = this.searchValue === '' ? this.limit : 'ALL'
            const offset = this.searchValue === '' ? this.offset : 0
            var searchValueinitial = ''
            if (this.searchValue !== '') {
                var stagenameSeparate = this.searchValue.split(' ')
                if (stagenameSeparate.length > 1) {
                    for (let index2 = 0; index2 < stagenameSeparate.length; index2++) {
                        searchValueinitial += stagenameSeparate[index2] + '_'
                    }
                    searchValueinitial = searchValueinitial.slice(0, -1)
                } else {
                    searchValueinitial = this.searchValue
                }
            } else {
                searchValueinitial = this.searchValue
            }
            API.getPlatformsLedgers(limit, offset, 'Chaturbate', searchValueinitial)
                .then((res) => {
                    if (this.searchValue !== '') {
                        this.ledgers = res
                    } else {
                        res.map(ledger => { this.ledgers.push(ledger) })
                        this.offset += this.limit
                        this.itemFlag = true
                    }
                })
        },
        loadMore() {
            this.busy = true
            if (!this.listEnd) {
                setTimeout(() => {
                    if (this.ledgers.length < this.offset) {
                        this.listEnd = true
                        return
                    }
                    if (this.itemFlag) {
                        this.getPlatformsLedgers()
                        this.busy = false
                    } else {
                        this.loadMore()
                    }
                }, 1000)
            }
        },
        getBetsModels() {
            API.getModelsPlatformRanking('Chaturbate', 'ASC')
                .then((res) => {
                    this.worseModels = res
                })
        },
        getWorseModels() {
            API.getModelsPlatformRanking('Chaturbate', 'DESC')
                .then((res) => {
                    this.bestModels = res
                })
        },
        getTotalTokensToday() {
            API.getTotalTokensToday('Chaturbate')
                .then((res) => {
                    this.totalTokensToday = res.total
                })
        },
        getWorseDay() {
            API.getDayPlatformRanking('Chaturbate', 'ASC')
                .then((res) => {
                    this.worseDay = res
                })
        },
        getBestDay() {
            API.getDayPlatformRanking('Chaturbate', 'DESC')
                .then((res) => {
                    this.bestDay = res
                })
        },
        getPlatformsStudioTotal() {
            API.getPlatformsStudioTotal('Chaturbate')
                .then((res) => {
                    this.studioTotal = res.total
                })
        }
    },
    mounted() {
        this.getTotalModels()
        this.getTotalDollars()
        this.getPlatformsLedgers()
        this.getBetsModels()
        this.getWorseModels()
        this.getTotalTokensToday()
        this.getWorseDay()
        this.getBestDay()
        this.getPlatformsStudioTotal()
    },
    beforeMount() {
        this.$root.$emit('changePlatform', this.$route.name)
    }
}
</script>

<style scoped>
    .reports{
        width: 100%;
        height: 78vh;
        padding: 20px;
        background-color: #cdcdcd;
        display: flex;
    }
    .reports > div {
        width: 50%;
        text-align: center;
        height: 100%;
    }
    .reports > div > div{
        width: 100%;
        text-align: center;
        height: 100%;
    }
    .reports > div > div > div.informes {
        width: 100%;
        height: 30%;
        padding: 10px;
    }
    .reports > div > div > div.ledgers {
        width: 100%;
        height: 70%;
        padding: 10px;
    }
    .reports > div > div > div.modelos {
        width: 100%;
        height: 50%;
        padding: 10px;
    }
    .reports > div > div > div.fechas {
        width: 100%;
        height: 50%;
        padding: 10px;
    }
    .reports > div > div > div.informes > div{
        background-color: #2b2926;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        border-style: outset;
        padding: 10px;
        color: #fff;
        display: flex;
    }
    .reports > div > div > div.informes > div > div{
        width: 33%;
        height: 100%;
        position: relative;
    }
    .reports > div > div > div.informes > div > div > label{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-weight: bold;
    }
    .reports > div > div > div.informes > div > div > label > span{
        font-size: 28px;
    }
    .reports > div > div > div.ledgers > div{
        background-color: #2b2926;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        border-style: outset;
        padding: 10px;
        color: #fff;
    }
    .reports > div > div > div.ledgers > div > center{
        margin-top: 20px;
        overflow-y: auto;
        height: 80%;
    }
    .reports > div > div > div.ledgers > div > center > table > thead > tr > th {
        border-style: outset;
        padding: 20px 40px;
        text-align: center;
    }
    .reports > div > div > div.ledgers > div > center > table > tbody > tr > td {
        border-style: outset;
        padding: 10px 20px;
        text-align: center;
    }
    .reports > div > div > div.modelos > div{
        background-color: #2b2926;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        border-style: outset;
        padding: 10px;
        color: #fff;
        display: inline-flex;
    }
    .reports > div > div > div.modelos > div > div {
        width: 100%;
        text-align: center;
    }
    .reports > div > div > div.modelos > div > div > center > table > thead > tr > th{
        padding: 20px 40px;
    }
    .reports > div > div > div.modelos > div > div > center > table > tbody > tr > td{
        padding: 20px 40px;
    }
    .reports > div > div > div.fechas > div{
        background-color: #2b2926;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        border-style: outset;
        padding: 10px;
        color: #fff;
        display: inline-flex;
    }
    .reports > div > div > div.fechas > div > div{
        width: 50%;
        height: 100%;
    }
    .reports > div > div > div.fechas > div > div > div{
        width: 100%;
        height: 50%;
        position: relative;
    }
    .reports > div > div > div.fechas > div > div > div > label{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-weight: bold;
        width: 100%;
    }
    .reports > div > div > div.fechas > div > div > div > label > span{
        font-size: 26px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Reportes/Plataformas/Chaturbate.vue